<template>
  <b-container>
    <b-row style="margin-top: 4em">
      <b-col>
        <h3 class="text-secondary">{{ $t("globals.new_inquiry") }}:</h3>
      </b-col>
    </b-row>
    <ulu-select-customer />
    <ulu-start-date v-if="getInquiryNew.customer.customerSet" />
    <b-row
      class="mt-4"
      v-if="getInquiryNew.customer.customerSet && getCustomerNotes"
    >
      <b-col cols="12">
        <h4 class="text-secondary">{{ $t("globals.customer_notes") }}:</h4>
      </b-col>
      <b-col cols="12">
        <b-form-textarea
          v-if="getCustomerNotes"
          v-model="getCustomerNotes"
          rows="3"
          disabled
        >
        </b-form-textarea>
      </b-col>
    </b-row>
    <ulu-inquiry-group-tabs-view
      style="margin-bottom: 4em"
      v-if="getInquiryNew.startingDateSet"
    />
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    "ulu-select-customer": () =>
      import(
        "@/components/inquiries/new_inquiry/select_customer/SelectCustomer"
      ),
    "ulu-start-date": () =>
      import("@/components/inquiries/new_inquiry/StartDate"),
    "ulu-inquiry-group-tabs-view": () =>
      import(
        "@/components/inquiries/new_inquiry/inquiries/InquiryGroupTabsView"
      )
  },
  computed: {
    ...mapGetters([
      "getInquiryNew",
      "getUserBrandPermissions",
      "getCustomerNotes"
    ])
  },
  created() {
    if (!this.getUserBrandPermissions.inquiry_create) {
      this.$router.push({ name: "dashboard" });
    }
  },
  beforeDestroy() {
    this.$store.commit("setNewInquiryClean");
  }
};
</script>
